<template>
  <div>
    <el-form
      class="elFormClass"
      :model="formParams"
      ref="ruleForm"
      label-width="auto"
      size="small"
    >
      <el-form-item label="EPC" prop="epc" :rules="formRules.requiredChange">
        <el-input
          v-model="formParams['epc']"
          clearable
          type="textarea"
          autosize
          placeholder="谨慎修改,通过扫描获取"
        ></el-input>
      </el-form-item>
    </el-form>
    <div style="margin-bottom:40px" :class="$store.state.readyState=='已连接'?'flex_between_nowrap':'flex_end'">
      <el-button type="main"  v-show=" $store.state.readyState=='已连接'" @click="$store.commit('WEBSOCKET_CLEAR')"
        >清空缓存</el-button
      >
      <div class="flex_end">
        <span :style="$dynamicColor($store.state.readyState)">{{
          $store.state.readyState
        }}</span>
        <el-button
          type="main"
          @click="takeTitlestart(!$store.state.skreadyState)"
          >{{
            $store.state.skreadyState
              ? "关闭扫描"
              : $store.state.readyState !== "已连接"
              ? "开启连接"
              : "开始扫描"
          }}</el-button
        >
      </div>
    </div>

    <div class="dialog_bottom">
      <el-button class="dialog_close" size="small" @click="closeDialog"
        >取 消</el-button
      >
      <el-button
        class="dialog_submit"
        size="small"
        style="width:100px"
        type="submit32"
        @click="submit"
        >确 定</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    currentIndex: Number,
    parentform: Object,
  },
  data() {
    return {
      formParams: {},
    };
  },
  mounted() {},
  watch: {
    "$store.state.resoveMsg"(newval, oldval) {
      if (newval && !this.formParams.epc) {
             this.$store.commit("WEBSOCKET_RFIDOFF");

        this.$set(this.formParams, "epc", newval.substr(6));
        this.$success("已自动填充EPC");
      }
    },
  },
  methods: {
    init() {
      this.$store.commit("WEBSOCKET_RFIDON");
    },
    submit() {
      this.$formValidate(this, "ruleForm").then(() => {
        setTimeout(() => {
          this.closeDialog();
        });

        this.$set(
          this.parentform.items[this.currentIndex],
          "assetEpc",
          this.formParams.epc
        );
      }).catch(()=>{});
    },
   takeTitlestart(boolean) {
      if (this.$store.state.readyState !== "已连接" && boolean) {
        this.$store.commit("createSocket");
      } else {
        if (this.formParams.assetEpc) {
          this.$success("开启失败:请清空EPC", "error");

          return;
        } else {
          this.$alertMsg.confirm(
            `确定${boolean ? "开始扫描" : "停止扫描"}吗？`,
            () => {
              this.$store.commit(
                "send",
                boolean
                  ? {
                      data: "16DF040201340030",
                      code: 3,
                    }
                  : {
                      data: "16DF040201350031",
                      code: 3,
                    }
              );
            }
          );
        }
      }
    },
  },
};
</script>
<style scoped></style>
